import { jsx as E } from "react/jsx-runtime";
import { createContext as d, useState as y, useCallback as A, useMemo as a, useContext as S } from "react";
import { SessionService as p } from "@nextgen-web-framework/core";
import { UNAVAILABLE_CONTEXT_ERROR as f } from "../../ErrorLabels.js";
import { UserType as e } from "./types/propsType.js";
import { AccountType as U } from "./types/propsType.js";
const o = d({
  session: {},
  updateSession: () => {
  }
});
function B(s) {
  const [t, i] = y(s.session);
  s.session && p.setSession(s.session);
  const n = A((c) => {
    i((u) => {
      const m = {
        ...u,
        ...c
      };
      return p.setSession(m), m;
    });
  }, []), r = a(
    () => ({
      session: t,
      updateSession: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ E(o.Provider, { value: r, children: s.children });
}
function C() {
  const { session: s } = S(o);
  return { session: s, isAnonymous: () => !s.type || s.type === e.ANONYMOUS, isRegistered: () => s.type === e.REGISTERED, isABO: () => s.type === e.ABO, isMember: () => s.type === e.MEMBER, isEmployee: () => s.type === e.EMPLOYEE, isActor: () => !!s.act };
}
function T() {
  if (!o)
    throw new Error(f);
  const { updateSession: s } = S(o);
  return s;
}
export {
  U as AccountType,
  B as SessionProvider,
  e as UserType,
  C as useSession,
  T as useSessionUpdate
};
//# sourceMappingURL=SessionProvider.js.map
